import { localStorage } from 'dibs-browser-storage';
import SV from 'server-vars';
import { getBuyerId } from 'dibs-cookie-jar';

import { fetchTradeOnboardingEligibility } from './fetchTradeOnboardingEligibility';
import {
    PDP_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
    SB_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
    TRADE_ONBOARDING_TYPE_PDP,
    TRADE_ONBOARDING_TYPE_SB,
} from './constants';

export function hasSeenPdpTradeOnboardingModal() {
    const timesShown = localStorage.getItem(PDP_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesShown > 0;
}

export function hasSeenSbTradeOnboardingModal() {
    const timesShown = localStorage.getItem(SB_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesShown > 0;
}

const tradeOnboardingRuleFactory = ({ hasSeen, pageType }) => ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;

    if (!userId || !isUserTypeTrade || hasSeen) {
        return Promise.resolve(false);
    }

    return fetchTradeOnboardingEligibility(relayEnvironment, userId, pageType);
};

export const pdpTradeOnboardingRule = tradeOnboardingRuleFactory({
    hasSeen: hasSeenPdpTradeOnboardingModal(),
    pageType: TRADE_ONBOARDING_TYPE_PDP,
});

export const sbTradeOnboardingRule = tradeOnboardingRuleFactory({
    hasSeen: hasSeenSbTradeOnboardingModal(),
    pageType: TRADE_ONBOARDING_TYPE_SB,
});
